<template>
  <div class="simulation-result">
    <v-card width="240" height="100%" class="pt-3 px-2 simulation-result-inner">
      <v-card-text class="body-1 text-md-center font-weight-bold">
        シミュレーション結果（概算)
      </v-card-text>
      <AppOverlay v-model="isLoading">
        <AppLoadingSpinner text="シミュレーション実行中..." class="ma-3" />
      </AppOverlay>
      <ResultList v-if="displayResult()">
        <!--<ResultListItem
          v-if="isSuperAdmin"
          :value="simulation.roughUu"
          title="roughユーザー数"
          unit="UU"
          local-string
        />-->
        <ResultListItem
          :value="simulation.uu"
          title="ユーザー数"
          unit="UU"
          local-string
        />
        <ResultListItem
          :value="simulation.imps"
          title="インプレッション"
          unit="imp"
          local-string
        />
        <ResultListItem
          :value="simulation.clicks"
          unit="click"
          title="クリック"
          local-string
        />
        <ResultListItem
          :value="simulation.ctr"
          title="CTR（クリック率）"
          unit="%"
        />
        <ResultListItem
          :value="simulation.revenue"
          title="消化見込額"
          prefix="¥"
          local-string
        />
      </ResultList>
      <div
        v-if="
          !displayResult() &&
            form.basicSetting.e2eResultHash === undefined &&
            (menuSetting.isUpperSimulationLocationsLimit() ||
              menuSetting.simulationLocationsAllCount > 20000) &&
            mode !== 'readonly'
        "
        class="e2e-area"
      >
        <p
          v-if="menuSetting.simulationLocationsAllCount > 20000"
          class="e2e-valid"
          style="font-size: small"
        >
          <b>取り込まれている地点数が、上限（20,000地点）を超えています。</b>
          <br /><br />
          <span style="color: black"
            >地点グループ・地点を削除して、20,000地点以下になるよう設定を修正してください。（無効なグループ・地点を含む）</span
          >
        </p>
        <p v-else>
          250地点以上設定されているため、リアルタイムでのシミュレーションはできません。<br />
          条件確定後、メールシミュレーションの申し込みをしてください。
        </p>
        <v-card-actions>
          <v-btn
            @click="onSubmit()"
            :disabled="
              !form.isLocationSettingComplete ||
                menuSetting.simulationLocationsAllCount > 20000
            "
            block
            small
            style="margin-top: 10px; margin-bottom: 10px; height: 40px;"
            color="primary"
          >
            条件を確定して<br />シミュレーションを申し込む
          </v-btn>
        </v-card-actions>
        <p
          v-if="
            menuSetting.isUpperSimulationLocationsLimit() &&
              !form.isLocationSettingComplete
          "
          class="e2e-valid"
        >
          半径が正しく設定されていません。<br />100-10000mの範囲で設定をしてください。
        </p>
      </div>
      <div
        v-if="
          !displayResult() &&
            form.basicSetting.e2eResultHash === undefined &&
            menuSetting.isUpperSimulationLocationsLimit() &&
            mode === 'readonly'
        "
        class="e2e-area"
      >
        250地点以上設定されておりシミュレーションのお申込みがされていないため、シミュレーション結果を表示できません。<br /><br />
        お手数ですが、共有元のアカウントへシミュレーションの申し込みを依頼してください。
      </div>
      <div
        v-if="!displayResult() && form.basicSetting.e2eResultHash !== undefined"
        class="e2e-area"
      >
        <span style="color: red"><b>シミュレーションは実行中です</b></span
        ><br /><br />完了後、アカウントに登録されているメールアドレスへ結果を送付いたします。<br />
        <b>※ お申し込み後、送信までに1-2時間程度お時間がかかります。</b>
      </div>
      <v-card-text v-if="simulationResult" class="caption red--text">
        シミュレーション結果は、配信金額を保証するものではありません
      </v-card-text>
      <v-card-text v-if="errorMessages" class="caption-area">
        <p
          :key="index"
          v-for="(message, index) in errorMessages"
          class="red--text caption"
        >
          {{ message }}
        </p>
      </v-card-text>
      <v-card-actions v-if="simulationResult">
        <v-btn @click="showResultModal" block small>
          詳細
        </v-btn>
      </v-card-actions>
      <v-card-actions v-if="simulationResult">
        <v-btn @click="onClickExportCsv" block small>CSV出力</v-btn>
      </v-card-actions>
      <v-card-actions v-if="simulationResult">
        <SimulationResultEncodeSelector v-model="selectedEncode" />
      </v-card-actions>
      <v-card-text>
        <p v-if="isFetchSimulationPoiLocations">地点数集計中</p>
        <p v-if="!isFetchSimulationPoiLocations">
          有効地点数:
          <span
            :style="{
              color: menuSetting.isUpperSimulationLocationsLimit() ? 'red' : '',
            }"
            >{{ menuSetting.simulationLocationsCurrentCount }}
          </span>
          地点
        </p>
        <p
          v-if="
            menuSetting.simulationLocationsAllCount > 20000 &&
              !isFetchSimulationPoiLocations
          "
        >
          取り込み地点数<br />
          <span style="color: red">{{
            menuSetting.simulationLocationsAllCount
          }}</span>
          / 20000 地点
        </p>
      </v-card-text>
      <v-card-text
        v-if="
          mode !== 'readonly' ||
            (menuSetting.e2eResultHash === undefined && !simulationResult)
        "
      >
        <p style="color: red; font-weight: bold;">注意</p>
        <p style="color: red">
          250地点以上設定されている場合、リアルタイムでのシミュレーションは実行できません
        </p>
        <p>
          有効地点数が250地点以上の場合シミュレーションを申し込み後、メールにて結果が送信されます。<br />
          ※ お申し込み後、<b>送信までに1-2時間程度時間がかかります。</b>
        </p>
      </v-card-text>
      <!--<v-checkbox
        v-if="isSuperAdmin"
        v-model="isUUFixedMode"
        class="uu-fixed-checkbox pl-3 pt-1"
        label="UU数を固定にする"
        dence
      />-->
    </v-card>
    <ResultDetailModal
      v-if="simulationResult"
      @changeEncode="onChangeEncode"
      @exportCsv="onClickExportCsv"
      :encode="selectedEncode"
      :simulation-result="simulationResult"
      v-model="isShowResultModal"
    />
  </div>
</template>

<script>
import { Subject } from 'rxjs'
import {
  debounceTime,
  switchMap,
  map,
  tap,
  takeUntil,
  filter,
} from 'rxjs/operators'
import { mapActions, mapGetters } from 'vuex'
import ResultList from './SimulationResultList'
import ResultListItem from './SimulationResultListItem'
import ResultDetailModal from './SimulationResultDetailModal'
import {
  SimulationRepository,
  E2eSimulationRepository,
  SimulationSubjectBuilder,
  Steps,
} from '@/models/Simulation'
import {
  translateFormToE2eSimulation,
  translateFormToSimulation,
} from '@/models/Simulation/translateFormToSimulation'
import { snackbarType } from '@/vuex/modules/ui/snackbar/constants'
import { CsvUtil } from '@/middlewares/CsvUtil'
import { modes } from '@/vuex/modules/simulation/constants'
import Encode from '@/constants/encode'
import SimulationResultEncodeSelector from './SimulationResultEncodeSelector'
import isEqual from 'lodash/isEqual'

const DEBOUNCE_TIME = 3000 // 3秒以内の連続変更はシミュレーションを走らせない
const POLLING_TIMEOUT = 60 * 1000 // 1分
const POLLING_INTERVAL = 2000 // 1秒間隔

export default {
  name: 'SimulationResult',
  components: {
    SimulationResultEncodeSelector,
    ResultDetailModal,
    ResultListItem,
    ResultList,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    isFetchSimulationPoiLocations: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      agencyId: this.$route.params.agencyId,
      isNew: true,
      onDestroy$: new Subject(),
      simulationResult: null,
      conditionHash: null,
      isVisitedAdvancedSetting: false, // 高度な設定を1度でも訪れたか
      isSimulationExecuted: false, // シミュレーションが1度でも実行されたか
      isLoading: false,
      isShowResultModal: false,
      isUUFixedMode: false,
      selectedEncode: Encode.SHIFT_JIS,
      isLocationCountConfirmed: false,
    }
  },
  computed: {
    ...mapGetters('simulation', ['mode', 'currentStep']),
    ...mapGetters('account', ['isSuperAdmin']),
    menuSetting() {
      return this.form.deliverySetting.menuSetting
    },
    simulation() {
      if (!this.simulationResult) {
        return false
      }
      return this.simulationResult.simulation
    },
    isSimulatable() {
      return (
        (this.form.isSimulatable && this.isVisitedAdvancedSetting) ||
        this.menuSetting.e2eResultHash !== undefined
      )
    },
    errorMessages() {
      const messages = []
      const hasSimulatableGroup =
        this.menuSetting.simulationCustomLocationGroups.hasSimulatableGroup ||
        this.menuSetting.simulationPoiLocationGroups.hasSimulatableGroup

      // 初回訪問時
      if (!this.isVisitedAdvancedSetting && !hasSimulatableGroup) {
        messages.push('有効な地点グループを登録してください')
      }
      // 高度な設定画面訪問済みかつ有効な地点なし
      if (this.isVisitedAdvancedSetting && !hasSimulatableGroup) {
        messages.push(
          '有効な地点グループおよび、地点がありません。有効な地点グループを登録してください。',
        )
      }
      // 高度な設定画面未訪問かつ有効な地点あり
      if (
        !this.menuSetting.isUpperSimulationLocationsLimit() &&
        hasSimulatableGroup &&
        !this.isVisitedAdvancedSetting
      ) {
        messages.push('▶を押すとシミュレーションが実行されます')
      }
      // 高度な設定に不備あり
      if (!this.form.advancedSetting.isSimulatable) {
        messages.push(
          '高度な設定に不備がありシミュレーションが実行できません。 シミュレーションを実行するには高度な設定を修正してください。',
        )
      }
      return messages.length > 0 ? messages : false
    },
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.getSimulation()
        this.confirmLocationCount()
        this.confirmLocationCountOver20k()
      },
    },
    currentStep(step) {
      // 新規のみの処理
      if (this.mode === modes.ADD) {
        // 既に高度な設定に訪問済みの場合は何もしない
        if (this.isVisitedAdvancedSetting) {
          return false
        }
        // 高度な設定を初めて訪問した場合の処理
        if (step === Steps.ADVANCED) {
          this.isVisitedAdvancedSetting = true
          this.getSimulation()
        }
      }
    },
  },
  created() {
    this.isVisitedAdvancedSetting = this.form.basicSetting.id !== undefined
    if (this.form.basicSetting.e2eResultHash === undefined) {
      // 250地点未満の場合
      // 各Subjectを初期化
      this.initializeSubjectForNotE2e()

      // 各Subjectを購読
      this.subscriptionForm()
      this.subscriptionUUFixedModeForm()
      this.subscriptionSimulation()

      if (this.mode !== modes.ADD) {
        // 既存のシミュレーションは既に高度な設定を訪れている
        this.isVisitedAdvancedSetting = true

        this.getSimulation()
      }
    } else {
      // e2e Simとして登録済みの場合
      this.initializeSubjectForE2e()
      this.getE2eSimulationResult()
    }
  },
  destroyed() {
    this.onDestroy$.next()
  },
  methods: {
    ...mapActions('snackbar', {
      showSnackbar: 'SHOW_SNACKBAR',
    }),
    initializeSubjectForNotE2e() {
      this.formSubject$ = new Subject()
      this.formSubjectForUUFixedMode$ = new Subject()
      this.simulationSubject$ = SimulationSubjectBuilder.createBuilder()
        .addInterval(POLLING_INTERVAL)
        .addTimeout(POLLING_TIMEOUT)
        .build()
    },
    initializeSubjectForE2e() {
      this.formSubject$ = new Subject()
      this.formSubjectForUUFixedMode$ = new Subject()
    },
    subscriptionForm() {
      this.formSubject$
        .pipe(
          debounceTime(DEBOUNCE_TIME),
          filter(() => this.isVisitedAdvancedSetting),
          filter(form => form.isSimulatable),
          // 旧シミュレーションプランはシミュレーションを走らせない
          filter(form => form.basicSetting.ownerProfileMenu !== undefined),
          tap(() => this.startLoading()),
          map(form => translateFormToSimulation(form)),
          switchMap(form => SimulationRepository.create(form)),
          takeUntil(this.onDestroy$),
        )
        .subscribe(
          ({ conditionHash }) => {
            this.conditionHash = conditionHash
            this.simulationSubject$.next(conditionHash)
          },
          () => this.onSimulationError(),
        )
    },
    subscriptionUUFixedModeForm() {
      this.formSubjectForUUFixedMode$
        .pipe(
          debounceTime(DEBOUNCE_TIME),
          filter(() => this.isVisitedAdvancedSetting),
          filter(form => form.isSimulatable),
          tap(() => this.startLoading()),
          map(form => translateFormToSimulation(form)),
          switchMap(form => SimulationRepository.getSimulationFromMock(form)),
        )
        .subscribe(
          response => this.onSimulationSuccess(response),
          () => this.onSimulationError(),
        )
    },
    subscriptionSimulation() {
      this.simulationSubject$
        .pipe(
          tap(() => this.endLoading()),
          takeUntil(this.onDestroy$),
        )
        .subscribe(
          response => this.onSimulationSuccess(response),
          () => this.onSimulationError(),
        )
    },
    getSimulation() {
      const formValue = JSON.parse(JSON.stringify(this.form))
      const lastValue = this.lastSimulation
      if (isEqual(lastValue, formValue) === false) {
        this.lastSimulation = formValue
        const formSubject = this.isUUFixedMode
          ? this.formSubjectForUUFixedMode$
          : this.formSubject$
        formSubject.next(this.form)
      }
    },
    onSimulationSuccess(response) {
      this.endLoading()
      this.isSimulationExecuted = true
      this.simulationResult = response.item.result
    },
    onSimulationError() {
      this.endLoading()
      this.showErrorSnackbar()

      /**
       *  一度例外が出たSubjectは破壊されるため
       *  Subjectを再構築する
       */
      this.initializeSubjectForNotE2e()

      // 再構築されたSubjectを購読する
      this.subscriptionForm()
      this.subscriptionUUFixedModeForm()
      this.subscriptionSimulation()
    },
    showErrorSnackbar() {
      this.showSnackbar({
        type: snackbarType.ERROR,
        message: 'シミュレーションの取得に失敗しました',
      })
    },
    async onClickExportCsv() {
      const name = this.form.basicSetting.name
      const csv = await SimulationRepository.getCsvByConditionHash(
        this.conditionHash,
      )
      CsvUtil.download(csv, name, this.selectedEncode)
    },
    showResultModal() {
      this.isShowResultModal = true
    },
    startLoading() {
      this.isLoading = true
    },
    endLoading() {
      this.isLoading = false
    },
    onChangeEncode(encode) {
      this.selectedEncode = encode
    },
    async getE2eSimulationResult() {
      this.isLoading = true
      this.conditionHash = this.form.basicSetting.e2eResultHash
      try {
        const response = await SimulationRepository.getByConditionHash(
          this.conditionHash,
        )
        if (!response) {
          this.simulationResult = undefined
          this.isLoading = false
          return
        }
        if (response.item.phase === 'cached') {
          this.simulationResult = response.item.result
          this.isVisitedAdvancedSetting = true
          this.isLoading = false
        }
      } catch (e) {
        console.error(e)
        throw e
      }
    },
    async onSubmit() {
      const validationMessages = this.form.basicSetting.validation()
      if (validationMessages.length > 0) {
        const validationMessage = validationMessages.join('\n')
        this.$confirm(`シミュレーション登録エラー`, {
          onlyOk: true,
          okText: '閉じる',
          body: validationMessage,
        })
        return
      }
      this.resistration = await this.$confirm('シミュレーション申し込み', {
        onlyOk: false,
        okText: '登録',
        cancelText: 'キャンセル',
        body:
          'メールシミュレーションを申し込みしますか？\n\n' +
          'メールシミュレーションを申し込み後、結果をCSVファイルを添付しメールにて送付いたします。\n' +
          '<b>なお結果の送付まで、1〜2時間程度かかります。</b>\n' +
          '\n' +
          'なお、1度メールシミュレーションを登録すると本シミュレーションは、編集不可となります。\n' +
          '条件を変更してシミュレーションを実行する場合、シミュレーションをコピーして新たなシミュレーションとして実行してください',
      })
      try {
        if (this.resistration) {
          this.$emit('toggleIsRegistering')
          await this.registrationE2eSimulation()
          this.$confirm(undefined, {
            onlyOk: true,
            okText: '閉じる',
            body:
              '登録が完了しました。\nシミュレーション結果の送付完了まで、<b>1〜2時間程度お待ち下さい。</b>',
          })
          this.$emit('toggleIsRegistering')
        }
      } catch (e) {
        this.$emit('toggleIsRegistering')
        this.$confirm(undefined, {
          onlyOk: true,
          okText: '閉じる',
          body:
            'シミュレーションの申込みに失敗しました。\nお手数ではございますが、再度シミュレーションのお申し込みをしてください。\n何度も失敗する場合、システム管理者へお問い合わせください。',
        })
        throw e
      }
    },
    simulationResultReset() {
      this.simulationResult = null
    },
    displayResult() {
      // e2e登録前
      if (
        this.menuSetting.isUpperSimulationLocationsLimit() &&
        this.form.basicSetting.e2eResultHash === undefined
      ) {
        this.simulationResultReset()
        return false
      }
      // e2e登録後かつ結果がない場合
      if (
        this.form.basicSetting.e2eResultHash !== undefined &&
        this.simulationResult === undefined
      ) {
        return false
      }
      // e2e登録後かつ結果がある場合
      if (this.form.basicSetting.e2eResultHash !== undefined) {
        return true
      }
      // 地点設定がない場合
      if (this.menuSetting.simulationLocationsCurrentCount === 0) {
        // 0地点に戻った場合にシミュレーション結果が残ってしまうため結果を一度リセット
        this.simulationResultReset()
        return false
      }
      // その他
      return true
    },
    reload() {
      this.$router.go({ path: this.$router.currentRoute.path, force: true })
    },
    confirmLocationCount() {
      if (
        this.menuSetting.simulationLocationsCurrentCount >= 100 &&
        !this.form.basicSetting.isReadOnly &&
        !this.isLocationCountConfirmed &&
        this.menuSetting.simulationLocationsAllCount <= 20000
      ) {
        this.$confirm(undefined, {
          onlyOk: true,
          okText: '閉じる',
          body:
            '250地点以上設定される場合、リアルタイムでのシミュレーションは実行できません。\n' +
            '250地点以上の場合、シミュレーションの申込後メールでの結果の送付となります。\n' +
            '\n' +
            '※ お申し込み後、<b>送信までに1-2時間程度時間がかかります。<b/>',
        })
        this.isLocationCountConfirmed = true
      }
    },
    confirmLocationCountOver20k() {
      if (this.menuSetting.simulationLocationsAllCount > 20000) {
        this.$confirm('地点取り込み上限エラー', {
          onlyOk: true,
          okText: '閉じる',
          body:
            'シミュレーション条件の保存・申し込みが可能な<b>地点数の上限は、20,000地点です。（無効にした地点・地点グループを含む）</b>\n\n' +
            '20,000地点を超える場合、下記が行えません。\n' +
            '・ シミュレーション条件の保存\n' +
            '・ シミュレーションのお申し込み\n\n\n' +
            '<b>下記のご対応をお願いいたします。</b>\n' +
            '・ 地点グループもしくは、地点を削除をして20,000地点以下になるよう設定を修正をしてください。（無効の地点・地点グループを含む）\n' +
            '・ カテゴリーをご指定の場合、エリアを絞り込むなど条件を絞り込んでください。',
        })
      }
    },
    redirectLoginLPSimulationEdit(simulationId) {
      this.$router.push({
        name: 'LoginLpSimulationEdit',
        params: {
          simulationId,
          initialStep: this.currentStep,
        },
      })
    },
    redirectAdvertiserSimulationEdit(simulationId) {
      this.$router.push({
        name: 'SimulationEdit',
        params: {
          agencyId: this.agencyId,
          advertiserId: this.form.basicSetting.advertiserId,
          simulationId,
          initialStep: this.currentStep,
        },
      })
    },
    async registrationE2eSimulation() {
      try {
        // シミュレーションプランがない場合先に登録
        if (this.form.basicSetting.id === undefined) {
          const response = await this.form.save()
          this.form.basicSetting.id = response.simulationPlan.id
          this.isNew = false
        } else {
          // シミュレーションプランが有る場合、現在の設定で上書きする。
          await this.form.update()
        }
        await E2eSimulationRepository.create(
          translateFormToE2eSimulation(this.form),
        )
        if (this.isNew) {
          this.reload()
        } else if (this.agencyId === undefined) {
          // agencyIdがない場合login lpからのシミュレーション
          this.redirectLoginLPSimulationEdit(this.form.basicSetting.id)
        } else {
          // 広告主画面からのシミュレーション
          this.redirectAdvertiserSimulationEdit(this.form.basicSetting.id)
        }
      } catch (e) {
        await console.error(e)
        throw new Error('シミュレーション登録に失敗しました。')
      }
    },
  },
}
</script>

<style lang="scss">
.simulation-result {
  position: relative;
  .uu-fixed-checkbox {
    position: absolute;
    bottom: 0;
    left: 0;
    .v-input__slot {
      margin-bottom: 0;
    }
  }
  .simulation-result-inner {
    overflow-y: scroll;
  }
  ::v-deep .v-card__text {
    padding: 12px;
  }
}
.caption-area {
  padding-top: 30px;
  padding-bottom: 20px;
}
.e2e-area {
  margin-top: 30px;
  margin-bottom: 20px;
}
.e2e-valid {
  color: red;
  padding-bottom: 10px;
  padding-top: 0px;
}
</style>
